/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateContactChatMessageResponseData,
  CreateContactChatMessageResponseDataFromJSON,
  CreateContactChatMessageResponseDataFromJSONTyped,
  CreateContactChatMessageResponseDataToJSON
} from './CreateContactChatMessageResponseData'

/**
 *
 * @export
 * @interface CreateContactChatMessageResponse
 */
export interface CreateContactChatMessageResponse {
  /**
   *
   * @type {number}
   * @memberof CreateContactChatMessageResponse
   */
  status?: number
  /**
   *
   * @type {CreateContactChatMessageResponseData}
   * @memberof CreateContactChatMessageResponse
   */
  data?: CreateContactChatMessageResponseData
}

export function CreateContactChatMessageResponseFromJSON(json: any): CreateContactChatMessageResponse {
  return CreateContactChatMessageResponseFromJSONTyped(json, false)
}

export function CreateContactChatMessageResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateContactChatMessageResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CreateContactChatMessageResponseDataFromJSON(json['data'])
  }
}

export function CreateContactChatMessageResponseToJSON(value?: CreateContactChatMessageResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateContactChatMessageResponseDataToJSON(value.data)
  }
}
